import React from 'react'

type NavArrowIconProps = {
  className?: string
  size?: number
}

export function NavArrowIcon({ className, size = 24 }: NavArrowIconProps) {
  return (
    <svg
      aria-hidden
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      height={size}
      width={size}
      viewBox="-231.24 -231.24 954.48 954.48"
      stroke="currentColor"
      strokeWidth="24.108196"
    >
      <g>
        <path d="M490.544,242.989L229.188,35.717c-1.16-0.916-2.708-1.088-4.04-0.448c-1.332,0.644-2.152,1.984-2.152,3.46v76.552H3.72 c-2.124,0-3.72,2.064-3.72,4.184v253.592c0,2.128,1.592,3.664,3.72,3.664h219.276v76.552c0,1.476,0.82,2.824,2.152,3.464 c0.528,0.252,1.092,0.38,1.664,0.38c0.848,0,1.692-0.284,2.384-0.832l261.36-207.268c0.916-0.728,1.448-1.836,1.448-3.016 C492,244.833,491.468,243.717,490.544,242.989z" />
      </g>
    </svg>
  )
}

